import { apiWobaBackend } from "@/services/api-woba-backend";
import { GetCompanyGroupByIdResponse } from "./get-company-group-by-id-list.types";

export const GetCompanyGroupsByIdList = async (
  groupIds: number[],
  companyId: number,
) => {
  const response: GetCompanyGroupByIdResponse = await apiWobaBackend.get(
    `/companies/${companyId}/groups?page=1&limit=100`,
  );

  return response.data.groups.filter((group) => groupIds.includes(group.id));
};
